export function getLocalStorageKey(storageKey) {
    return "_".concat(storageKey);
}
//# sourceMappingURL=getLocalStorageKey.js.map